module.exports = __webpack_public_path__ + "static/media/YF90_4.538cbc3a.jpg";